module.exports = __webpack_public_path__ + "img/emoji_010.220bd108.png";